import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./quasar";
import HighchartsVue from 'highcharts-vue';

Vue.use(HighchartsVue);

Vue.config.productionTip = false;

import "@/assets/css/style.css";
import i18n from "./i18n";

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
